module.exports = __webpack_public_path__ + "static/media/react_logo.81ac1182.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/tech_logos/react_logo.png
// module id = 78
// module chunks = 0